import { cn } from "@/lib/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentExclamation } from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import { Button } from "../ui/button";

type FeedbackButtonProps = {
  className?: string;
  label?: string | null;
};

export const FeedbackButton = ({
  className,
  label = "Feedback",
}: FeedbackButtonProps) => (
  <Button
    asChild
    id="feedback-button"
    size="sm"
    className={cn(className)}
    aria-label={label || "Feedback"}
    title={label || "Feedback"}
  >
    <a
      href="https://support.saltxcai.com/submit-ticket?product=salt-dash"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FontAwesomeIcon icon={faCommentExclamation} />
      {label}
    </a>
  </Button>
);
